<script>
import _map from "lodash/map";
import { banks, selectedBankId, setSelectedBankId } from "@/stores/banks";
import { computed, toRaw } from "vue";

export default {
  setup() {
    const banksList = computed(() => {
      return _map(banks.value, bank => {
        bank = toRaw(bank);
        bank.selected = bank.id === selectedBankId.value;
        return bank;
      });
    });

    const hasVisaPayment = computed(() => {
      let hasCard = false;

      banksList.value.forEach(option => {
        if (option.id.includes("card")) {
          hasCard = true;
        }
      });

      return hasCard;
    });

    return {
      banksList,
      setSelectedBankId,
      hasVisaPayment
    };
  }
};
</script>

<template>
  <div class="mt-20">
    <h4 class="text-center mb-8">{{ __("choose_payment_method") }}</h4>

    <div class="flex justify-center flex-wrap -m-3">
      <div class="p-3" v-for="bank in banksList" :key="`cf${bank.id}`">
        <button
          type="button"
          class="border-2px transition-colors duration-300 focus:outline-none"
          :class="bank.selected ? 'border-blue' : 'border-gray-200'"
          @click="setSelectedBankId(bank.id)"
        >
          <img
            class="h-16"
            :src="bank.image"
            :alt="bank.name"
            v-if="bank.image"
          />
          <template v-else>{{ bank.name }}</template>
        </button>
      </div>
    </div>

    <div class="text-center mt-12" v-if="hasVisaPayment">
      <p class="mb-2">{{ __("online_transactions_safe_description") }}</p>

      <div class="flex justify-center -m-2">
        <div class="p-2">
          <img
            :src="`./ui/images/bank/mastercard_id_check_vertical.svg`"
            alt="Mastercard ID-check"
            class="h-20"
          />
        </div>

        <div class="p-2">
          <img
            :src="`./ui/images/bank/visa_secure_vertical.svg`"
            alt="Visa Secure"
            class="h-20"
          />
        </div>
      </div>
    </div>
  </div>
</template>
